var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCozumluSorular = function SvgCozumluSorular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8827 42.5465C109.062 27.5679 132.206 22 151.406 22C203.004 22 245 63.7389 245 115.432C245 167.125 203.004 208.864 151.406 208.864C131.945 208.864 116.169 193.088 116.169 173.627C116.169 154.166 131.945 138.39 151.406 138.39C164.267 138.39 174.525 128.019 174.525 115.432C174.525 102.845 164.267 92.4746 151.406 92.4746C144.607 92.4746 137.667 94.6482 133.261 98.089C131.282 99.6348 129.784 101.432 128.7 103.672C127.62 105.903 126.475 109.56 126.475 115.432C126.475 134.893 110.698 150.669 91.2373 150.669C71.7763 150.669 56 134.893 56 115.432C56 83.3902 69.4123 58.5338 89.8827 42.5465Z",
    fill: "url(#paint0_linear_4330_4031)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.429 238.874V175.74C189.429 154.522 172.229 137.322 151.011 137.322C129.794 137.322 112.594 154.522 112.594 175.74V238.874C112.594 260.091 129.794 277.292 151.011 277.292C172.229 277.292 189.429 260.091 189.429 238.874Z",
    fill: "url(#paint1_linear_4330_4031)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.102 277.898C172.37 277.898 189.611 260.657 189.611 239.39C189.611 218.122 172.37 200.881 151.102 200.881C129.835 200.881 112.594 218.122 112.594 239.39C112.594 260.657 129.835 277.898 151.102 277.898Z",
    fill: "#2B81FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4031",
    x1: 244.967,
    y1: 22.0086,
    x2: 58.1525,
    y2: 210.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4330_4031",
    x1: 189.425,
    y1: 277.267,
    x2: 71.3625,
    y2: 212.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })))));
};
export default SvgCozumluSorular;